export default "__VITE_ASSET__DkfHh54$__"